import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";

// Lien réel vers l'autre version linguistique.
// Un <Link> rend bien un <a href>, donc Google suit le lien et découvre /en
// même sans passer par le sitemap.
const LangSwitch = () => {
  const { t, otherPath, otherLocale } = useI18n();

  return (
    <Link
      to={otherPath}
      className="lang-switch btn"
      title={t.nav.switchTitle}
      hrefLang={otherLocale}
      lang={otherLocale}
    >
      {t.nav.switchLabel}
    </Link>
  );
};

export default LangSwitch;
